/* Oh!My Snacks — Header scroll toggle + mega menu */
(function () {
  function init() {
    var headers = document.querySelectorAll('.oms-header');
    if (!headers.length) return;

    // ----- Scroll toggle -----
    var transparentHeaders = document.querySelectorAll('.oms-header[data-transparent="true"]');
    var THRESHOLD = 60;
    function updateScroll() {
      var scrolled = (window.scrollY || window.pageYOffset) > THRESHOLD;
      transparentHeaders.forEach(function (h) { h.classList.toggle('is-scrolled', scrolled); });
    }
    if (transparentHeaders.length) {
      window.addEventListener('scroll', updateScroll, { passive: true });
      window.addEventListener('resize', updateScroll);
      updateScroll();
    }

    // ----- Empty cart badge -----
    document.querySelectorAll('.oms-header__cart').forEach(function (c) {
      var n = c.querySelector('.oms-header__cart-count');
      if (n && (n.textContent || '').trim() === '0') c.setAttribute('data-empty', 'true');
    });

    // ----- Mega menu -----
    headers.forEach(function (header) {
      var mega = header.querySelector('.oms-mega');
      var trigger = header.querySelector('[data-mega-trigger="true"]');
      if (!mega || !trigger) return;

      var openTimer = null;
      var closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        header.classList.add('is-mega-open');
        trigger.classList.add('is-mega-active');
        mega.setAttribute('aria-hidden', 'false');
      }
      function close() {
        clearTimeout(openTimer);
        header.classList.remove('is-mega-open');
        trigger.classList.remove('is-mega-active');
        mega.setAttribute('aria-hidden', 'true');
      }
      function delayedOpen() {
        clearTimeout(closeTimer);
        openTimer = setTimeout(open, 80);
      }
      function delayedClose() {
        clearTimeout(openTimer);
        closeTimer = setTimeout(close, 180);
      }

      trigger.addEventListener('mouseenter', delayedOpen);
      trigger.addEventListener('mouseleave', delayedClose);
      trigger.addEventListener('focus', open);
      trigger.addEventListener('click', function (e) {
        // Block primary navigation on the trigger when mega has content; tap toggles instead
        if (header.classList.contains('is-mega-open')) close();
        else { e.preventDefault(); open(); }
      });

      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      mega.addEventListener('mouseleave', delayedClose);

      // Close on escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      // ----- Category hover swap -----
      var catItems = mega.querySelectorAll('.oms-mega__cat-item');
      var productSets = mega.querySelectorAll('[data-cat-products]');
      catItems.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          var idx = item.getAttribute('data-cat-index');
          catItems.forEach(function (i) { i.classList.toggle('is-active', i === item); });
          productSets.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-cat-products') === idx);
          });
        });
      });
    });
    // ----- Mobile drawer -----
    headers.forEach(function (header) {
      var burger = header.querySelector('[data-burger]');
      var drawer = header.querySelector('[data-drawer]');
      var overlay = header.querySelector('[data-drawer-overlay]');
      var closeBtn = header.querySelector('[data-drawer-close]');
      if (!burger || !drawer) return;

      function openDrawer() {
        header.classList.add('is-drawer-open');
        burger.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function closeDrawer() {
        header.classList.remove('is-drawer-open');
        burger.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (overlay) setTimeout(function () { overlay.hidden = true; }, 300);
      }
      burger.addEventListener('click', function () {
        if (header.classList.contains('is-drawer-open')) closeDrawer();
        else openDrawer();
      });
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    });
    // ----- Language selector -----
    document.querySelectorAll('.oms-lang').forEach(function (lang) {
      var toggle = lang.querySelector('[data-lang-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = lang.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!lang.contains(e.target)) {
          lang.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { lang.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();